import { InitializeReactWidget } from "@TmpApp/Utils";

export default function Widget($element) {
    InitializeReactWidget($element, import("./Price"));
}
